import Vue from 'vue';
import VueRouter from 'vue-router';
import VueGtag from "vue-gtag";
import * as uiv from 'uiv';
import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';

import 'bootstrap/dist/css/bootstrap.min.css';

import baseComponents from './components/base-components';
import router from './routes';
import store from './store';
import App from './App.vue';

import '../../base/filters';

Vue.config.productionTip = false;

Vue.use(VueRouter);

if (process.env.NODE_ENV == 'production' && process.env.VUE_APP_GOOGLE_ANALYTICS_ID) {
  Vue.use(
    VueGtag,
    { 
      appName: 'Acquisition - Perks Direct',
      config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID },
    },
    router
  );
}

Vue.use(uiv, { prefix: 'uiv' });
Vue.use(Vuelidate);
Vue.use(VueScrollTo);

baseComponents.forEach((component) => Vue.component(component.name, component));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
